export type { OptionGroupProps, OptionGroupSlots, OptionGroupState } from './components/OptionGroup/index';
export {
  OptionGroup,
  optionGroupClassNames,
  renderOptionGroup_unstable,
  useOptionGroupStyles_unstable,
  useOptionGroup_unstable,
} from './components/OptionGroup/index';
